import moment from 'moment';
import axios from '../../axios';

export default {
  namespaced: true,
  state: {
    selectedExperience: {},
    selectedDay: {},
    daysPlanned: [],
    experiencesSaved: [],
    currentExperiences: [],
    currentDaysPlanner: {},
    villaBookingItemId: 0,
    bookingItems: [],
    totalBookingItems: 0,
    totalPrice: 0,
  },
  getters: {
    getSelectedExperience: (state) => state.selectedExperience,
    getSelectedDay: (state) => state.selectedDay,
    getDaysPlanned: (state) => state.daysPlanned,
    getExperiencesSaved: (state) => state.experiencesSaved,
    getCurrentExperiences: (state) => state.currentExperiences,
    getCurrentDaysPlanner: (state) => state.currentDaysPlanner,
    getBookingItems: (state) => state.bookingItems,
    getTotalBookingItems: (state) => state.totalBookingItems,
    getTotalPrice: (state) => state.totalPrice,
  },
  mutations: {
    setBookingItems: (state, payload) => state.bookingItems = payload,
    setSelectedExperience(state, payload) {
      state.selectedExperience = payload;
    },
    setSelectedDay(state, payload) {
      state.selectedDay = payload;
    },
    setCurrentExperiences(state, payload) {
      state.currentExperiences = payload;
    },
    updateExperienceItem(state, payload) {
      const experienceItem = state.currentExperiences.find((item) => item.serviceId === payload.serviceId);
      const index = state.currentExperiences.findIndex((item) => item.serviceId == payload.serviceId);
      if (index > -1) {
        state.currentExperiences.splice(index, 1, payload);
      }
    },
    setDaysPlanned(state, payload) {
      state.daysPlanned = payload;
    },
    addVillaDaysToPlanner(state, payload) {
      const villaDaysPlanned = state.daysPlanned.find((item) => item.propertyId === payload.propertyId);
      if (villaDaysPlanned) {
        const index = state.daysPlanned.findIndex((item) => item.propertyId == payload.propertyId);
        state.daysPlanned.splice(index, 1, payload);
      }
      else {
        state.daysPlanned.push(payload);
      }
    },

    addExperienceBooking(state, payload) {
      // first add to general array with all experiences
      const experienceData = state.experiencesSaved.find((item) => item.uuid === payload.uuid);
      if (experienceData) {
        const index = state.experiencesSaved.findIndex((item) => item.uuid == payload.uuid);
        state.experiencesSaved.splice(index, 1, payload);
      }
      else {
        state.experiencesSaved.push(payload);
      }
      // ----- then add to planned days for selected day ------/
      // find days planned for this booking / villa
      const villaDaysPlanned = state.daysPlanned.find((booking) => booking.propertyId === payload.propertyId);
      const day = villaDaysPlanned.days.find((item) => moment(item.date).format('YYY-MM-DD') == moment(payload.date).format('YYY-MM-DD'));

      // get experiences array for that day and check if current experience exists
      const experienceDayData = day.experiences.find((item) => item.uuid === payload.uuid);
      const index = day.experiences.findIndex((item) => item.uuid == payload.uuid);
      if (experienceDayData) {
        // if exists replace and update item
        day.experiences.splice(index, 1, payload);
      }
      else {
        day.experiences.push(payload);
      }
    },

    removeExperience(state, payload) {
      state.experiencesSaved = state.experiencesSaved.filter((item) => (item.uuid != payload.uuid));

      const villaDaysPlanned = state.daysPlanned.find((item) => item.propertyId === payload.propertyId);
      const day = villaDaysPlanned.days.find((item) => moment(item.date).format('YYY-MM-DD') == moment(payload.date).format('YYY-MM-DD'));
      day.experiences = day.experiences.filter((item) => item.uuid != payload.uuid);
    },

  },
  actions: {
    updateBookingItems({ state }) {
      state.bookingItems = state.currentDaysPlanner?.days?.map((day) => day.experiences).flat().filter((item) => [3, 7].includes(item.status)).map((item) => {
        item.selected = true;
        return item;
      }) || [];
      state.totalBookingItems = state.bookingItems?.length || 0;
      state.totalPrice = state.bookingItems?.map((item) => item.quotedPrice).reduce((acc, val) => acc + val, 0) || 0;
    },
    requestExperiencePlanner({ state, dispatch }, villaBookingItemId) {
      return new Promise((resolve, reject) => {
        state.villaBookingItemId = villaBookingItemId;
        axios.get(`/core/itineraries/villabookingid/${villaBookingItemId}`)
          .then((res) => {
            state.currentDaysPlanner = res.data;
            dispatch('updateBookingItems');
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    checkIfChildAgesRequired({ state, commit }, payload) {
      const { id, adults, children, requestedDate } = payload;
      return new Promise((resolve, reject) => {
        axios.get(`/core/itineraries/pricing/childagesrequired/serviceid/${id}`, { params: { adults, children, requestedDate } })
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getPriceQuote({ state, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        axios.post(`/core/itineraries/pricing/getquote/serviceid/${payload.id}`, payload)
          .then((res) => {
            dispatch('updateBookingItems');
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    saveExperienceBooking({ state, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/core/itineraries', payload)
          .then((res) => {
            state.currentDaysPlanner = res.data;
            dispatch('updateBookingItems');
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    removeExperienceBooking({ state, dispatch }, id) {
      return new Promise((resolve, reject) => {
        axios.delete(`/core/itineraries/${id}`)
          .then((res) => {
            state.currentDaysPlanner = res.data;
            dispatch('updateBookingItems');
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    postExperienceBooking({ state, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        // {
        //   'requiresZohoSync': true,
        //   'requiresZohoSyncWithSeperateThread': true,
        //    id:0, // set by backend - will be unique
        //    experienceBookingItemId: // set by backend

        //   'villaBookingItemId': 0,
        //   'propertyId': 0,
        //   'serviceId': 0,
        //   'date': '2022-12-11T15:06:25.865Z',
        //   'time': 'string',
        //   'guestsLabel': 'string',
        //   'notes': 'string',
        //   'status': 'bookmarked',
        //   'adults': 0,
        //   'children': 0,
        //   'infants': 0,
        //   'quotedPrice': 0,
        //   'childrenAges': [ 0 ],

        //   'addedDate': '2022-12-11T15:06:25.865Z',
        //   'createdAdminUserId': 0,
        //   'currentUserId': 0,
        //   'context': 'web'
        // }

        axios.post('/core/bookings/itinerary/request', payload)
          .then((res) => {
            dispatch('requestExperiencePlanner', state.villaBookingItemId);
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // returns the consolidated booking id.
    consolidateForPayment({ state, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/core/bookings/itinerary/consolidateforpayment', payload)
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
